<ion-header>
  <ion-toolbar>
    <ion-title>Find location</ion-title>
  </ion-toolbar>
</ion-header>

<div class="inner-content ion-padding">
  <form (ngSubmit)="find()">
    <ion-item class="ion-margin-vertical">
      <ion-icon slot="start" src="assets/custom-icons/location-icon.svg"></ion-icon>
      <ion-input
        [value]="address"
        [ngModelOptions]="{standalone: true}"
        (ionInput)="ionInput($any($event))"
        inputmode="text"
        required
        label="Location Address"
        labelPlacement="floating"
        placeholder=""
      ></ion-input>
    </ion-item>
    <ion-item class="ion-margin-vertical" lines="none" *ngIf="error">
      <ion-text color="danger">
        <h4>{{error}}</h4>
      </ion-text>
    </ion-item>

    <ion-item button *ngFor="let location of predictedLocations" (click)="selectPredictedLocation(location)">
      <ion-icon slot="start" name="location-outline"></ion-icon>
      <ion-label>{{location.description}}</ion-label>
    </ion-item>

    <ion-button type="submit" expand="full" [disabled]="disableSubmit()" class="ion-no-margin">
      Find
    </ion-button>
  </form>
</div>
  